module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Thin.cbd23daa.ttf";